import React from "react";
import { Button, Stack } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import { StatusCode } from "../../../../services/helper";
import ButtonLoader from "../../../../components/Common/ButtonLoader";
import { usePic } from "../../../../context/PicProvider";
import { nearMissIncidentData } from "../../../../redux/slice/QuickReportSlice";
import ProductDetailsButtonView from "../common/ProductDetailsButtonView";

const ReportSummary = () => {
  const { nearMissFormData, status, quichReportData } = useSelector(
    (state) => state.QUICKREPORT
  );
  const dispatch = useDispatch();
  const { setSuccessPopup } = usePic();
  const postApiData = async (e) => {
    e.preventDefault();
    const payload = {
      first_name: nearMissFormData?.firstName?.value,
      last_name: nearMissFormData?.lastName?.value,
      country_code: nearMissFormData?.phoneNumberCode?.value,
      contact_number: nearMissFormData?.phoneNumber?.value,
      email: nearMissFormData?.email?.value,
      incident_date: nearMissFormData?.date?.value,
      incident_time: nearMissFormData?.time?.value,
      description: nearMissFormData?.summary?.value,
      item_used: [],
      kit_id: quichReportData?.kit_data?._id,
      company_id: quichReportData?.kit_data?.company_id,
      location_of_incident: quichReportData?.kit_data?.location_name,
      area_of_incident: quichReportData?.kit_data?.area,
    };
    try {
      const response = await dispatch(nearMissIncidentData(payload));
      const result = response?.payload;
      if (result?.status === 200) {
        setSuccessPopup({
          open: true,
          title: "Submission Complete",
          primaryText: "Done",
          message: "Your report has been submitted successfully.",
          primaryURL: "/standardwithquickreport",
          child: null,
        });
      }
    } catch (error) {
      console.error("Error submitting the incident data:", error);
    }
  };

  return (
    <div className="quickthreepage flex-grow-1 d-flex flex-column justify-content-between">
      <div className="incident-report-container">
        <div className="incidentmadeinfo">
          <h6 className="fw-bold text-center">Reported By</h6>
          <hr />
          <Stack gap={2}>
            <div className="d-flex align-items-center flex-wrap gap-1">
              <h5 className="mb-0">Name:</h5>
              <span className="text-break">
                {nearMissFormData?.firstName?.value}{" "}
                {nearMissFormData?.lastName?.value}
              </span>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-1">
              <h5 className="mb-0">Contact Number: </h5>
              <span>
                {nearMissFormData?.phoneNumberCode?.value}
                {nearMissFormData?.phoneNumber?.value}
              </span>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-1">
              <h5 className="mb-0">Email: </h5>
              <span className="text-break">
                {nearMissFormData?.email?.value}
              </span>
            </div>
          </Stack>
        </div>
        <div className="incidentmadeinfo mt-4">
          <h6 className="fw-bold text-center">Type of Incident</h6>
          <hr />
          <Stack gap={2}>
            <div className="d-flex align-items-center flex-wrap gap-1">
              <h5 className="mb-0">Date:</h5>
              <span className="text-break">
                {nearMissFormData?.date?.value}
              </span>
            </div>
            <div className="d-flex align-items-center flex-wrap gap-1">
              <h5 className="mb-0">Time:</h5>
              <span className="text-break">
                {nearMissFormData?.time?.value}
              </span>
            </div>
          </Stack>
        </div>
        <div className="incidentmadeinfo mt-4">
          <h6 className="fw-bold text-center">Summary of Incident</h6>
          <hr />
          {nearMissFormData?.summary.value ? (
            <div className="overflow-y-auto" style={{ maxHeight: "400px" }}>
              <p className="text-break m-0">
                {nearMissFormData?.summary?.value}
              </p>
            </div>
          ) : (
            <p className="mb-0">No summary found</p>
          )}
        </div>
        <div className="incidentmadeinfo mt-4">
          <h6 className="fw-bold text-center">
            First Aid Kit and Location Details
          </h6>
          <hr />
          <h6 className="quickheading mb-3 letter_spacing fw-bold">
            <span> {quichReportData?.kit_data?.brand}</span>
            <span className="ms-2">
              {quichReportData?.kit_data?.model_number}
            </span>
            <div> {quichReportData?.kit_data?.product_name}</div>
          </h6>
        </div>
        <ProductDetailsButtonView />
      </div>
      <div className="incident-report-form-footer-action">
        <NavLink to="/near-miss-report-info" className={"nav-link"}>
          <Button variant="dark" className="fw-bold h-100">
            Cancel
          </Button>
        </NavLink>
        <div>
          <Button
            type="submit"
            onClick={(e) => postApiData(e)}
            className="button_custom text-black fw-bold d-flex align-items-center justify-content-center"
            disabled={status === StatusCode.LOADING}
          >
            {status === StatusCode.LOADING ? <ButtonLoader /> : "Submit Report"}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReportSummary;
